<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('product.products') }}</span>
        <h3 class="page-title">{{ $t('productCategories.title') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success" @click.prevent="$router.push('/kategorie-produktow/nowa')">
          <i class="material-icons">add</i>
          {{ $t('productCategories.addCategory') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('productCategories.name') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(category, index) of flatCategories"
            :key="'category-' + index">
            <td class="align-middle">
              <span v-pure-html="category.name"></span>
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/kategorie-produktow/edycja/' + category.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                @click.native="removeCategory(category.id)"
                :disabled="removeInProgress"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="flatCategories.length === 0">
            <td
              colspan="3"
              class="text-center">
              {{ $t('productCategories.noCategoriesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'product-categories',
  computed: {
    flatCategories() {
      let result = [];
      let stack = this.categories.map(category => ({ ...category, prefix: '' }));

      while (stack.length > 0) {
        let current = stack.shift();

        result.push({
          id: current.id,
          name: current.prefix + current.name
        });

        if (current.children && current.children.length > 0) {
          stack = [
            ...current.children.map(child => ({ ...child, prefix: current.prefix + '<span style="color: #aaa">&ndash;</span> ' })),
            ...stack
          ];
        }
      }

      return result;
    }
  },
  data() {
    return {
      categories: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/categories/items', 'categories', {}, 'get');
    },
    removeCategory (categoryID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/categories/delete/',
        id: categoryID,
        successTitle: this.$t('productCategories.removeCategorySuccessTitle'),
        successText: this.$t('productCategories.removeCategorySuccessText'),
        confirmTitle: this.$t('productCategories.removeCategoryConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('productCategories.removeCategoryErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

